export const BOOKING_ROUTE = 'BookingRoute/';
export const PAXCONNECT = 'PaxConnect/';

export const PAYMENT = 'Payment/';
export const PAYMENT_REDIRECT = 'payment/redirect';
export const CHECKOUT_API = '/checkout/';

export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const HTTP_BAD_REQUEST = 400;
